"use client"

import { Card, Skeleton } from "antd"

const NewsItemSkeleton = () => {
  return (
    <Card
      hoverable
      cover={(
        <Skeleton.Image
          active
          styles={{
            content: {
              height: 180,
              width: '100%',
              borderBottomLeftRadius: 0,
              borderBottomRightRadius: 0,
            }
          }}
        />
      )}
      style={{
        borderRadius: "8px",
        overflow: "hidden",
        border: "none",
        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
        transition: "all 0.3s ease",
        height: "320px",
      }}
      styles={{
        body: {
          padding: "1rem",
          display: "flex",
          flexDirection: "column",
          height: "140px",
        }
      }}
    >
      <div style={{ marginBottom: "0.5rem" }}>
        <Skeleton
          paragraph={false}
          styles={{
            title: {
              margin: 0,
              height: '1.5rem',
              width: '7rem'
            }
          }}
        />
      </div>

      <Skeleton
        active
        paragraph={false}
        styles={{
          title: {
            margin: 0,
            marginBottom: "0.5rem",
            fontSize: "1.1rem",
            lineHeight: "1.3",
            color: "#262626",
            fontWeight: "600",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            textOverflow: "ellipsis",
            height: "2.6rem",
          }
        }}
      />

      <Skeleton
        title={false}
      />
    </Card>
  )
}

export default NewsItemSkeleton